/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Home_BodyInputs */



/**
* | output |
* | --- |
* | "Your partner tools are coming soon — they'll appear here." |
*
* @param {Partner_Home_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_home_body = /** @type {((inputs?: Partner_Home_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Home_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre Partner-Tools sind bald verfügbar – sie erscheinen hier.")
	return /** @type {LocalizedString} */ ("Your partner tools are coming soon — they'll appear here.")
});